import { createSlice } from "@reduxjs/toolkit";
import { UPLOAD_STATUSES } from "components/Modal/UploadFilesModal/constants";

const initialState = {
  folderId: undefined,
  folderName: undefined,
  documentId: undefined,
  feature: undefined,
  fileUploadStates: {}, // { hash: { status, id, error} }
  eventSource: null, // controller used for SSE session
  currentFlowId: null, // flowId of the active upload session
  stillDownloadingExternally: false,
};

export const foldersSlice = createSlice({
  name: "folders",
  initialState,
  reducers: {
    setCurrentFolder: (state, action) => {
      state.folderId =
        action.payload.folderId !== undefined
          ? Number(action.payload.folderId)
          : undefined;
      state.folderName = action.payload.folderName;
      state.documentId =
        action.payload.documentId !== undefined
          ? Number(action.payload.documentId)
          : undefined;
    },
    initFileUploadStates: (state, action) => {
      const files = action.payload;
      files.forEach((file) => {
        state.fileUploadStates[file.hash] = {
          status: UPLOAD_STATUSES.WAITING,
          error: null,
        };
      });
    },
    cleanupFiles: (state, action) => {
      const files = action.payload;
      const hashes = files.map((file) => file.hash);
      Object.keys(state.fileUploadStates).forEach((hash) => {
        if (!hashes.includes(hash)) {
          delete state.fileUploadStates[hash];
        }
      });
    },
    updateFileUploadState: (state, action) => {
      const { hash, status, id, error = null } = action.payload;
      if (hash !== undefined) {
        state.fileUploadStates[hash.trim()] = { status, id, error };
      }
    },
    clearFileUploadStates: (state) => {
      state.fileUploadStates = {};
    },
    setEventSource: (state, action) => {
      state.eventSource = action.payload;
    },
    setCurrentFlowId: (state, action) => {
      state.currentFlowId = action.payload;
    },
    setStillDownloadingExternally: (state, action) => {
      state.stillDownloadingExternally = action.payload;
    },
  },
});

export const {
  setCurrentFolder,
  initFileUploadStates,
  cleanupFiles,
  updateFileUploadState,
  clearFileUploadStates,
  setCurrentFlowId,
  setEventSource,
  setStillDownloadingExternally,
} = foldersSlice.actions;

export default foldersSlice.reducer;
